<template>
  <div id="app">
    <transition
      mode="out-in"
      enter-active-class="fadeIn animated faster"
      leave-active-class="fadeOut animated faster"
    >
      <router-view></router-view>
    </transition>

    <tech></tech>
  </div>
</template>

<script>
import tech from '@zj/tech';
import { isQrcode } from '@/../config/config';

export default {
  name: 'app',
  components: { tech },
  data() {
    return {
      topImg: '',
      isFans: '',
    };
  },
  created() {
    this.topImg = this.$activity.topImg;
    this.isFans = this.$activity.isfans;
    if (!window.activity.start) this.swal('活动未开始', '', 'warning');
    else if (window.activity.end) this.swal('活动已结束', '', 'warning');
    if (!this.isFans && isQrcode) this.$router.push('/qrcode');
    else this.$router.push('/');
  },
};
</script>

<style lang="scss">
$rootUrl: "./assets/images/";

@import "./assets/scss/sweetAlert.reset.scss";

#app {
  // min-height: 100%;
  position: relative;
  overflow-x: hidden;
  // padding-bottom: vw2rem(25);
  > .container {
    width: 100%;
    min-height: 100vh;
    @include bg("bg.jpg");
    > .item {
      position: absolute;
    }
  }
}

body {
  background-color: #ffffff;
}

.my-scroll {
  $width: 0.2rem;
  overflow: hidden;
  overflow-y: auto;
  transform: translateX(0.3rem);
  &::-webkit-scrollbar {
    /*滚动条整体样式*/
    width: $width;
    border-radius: $width;
    overflow: hidden;
  }

  &::-webkit-scrollbar-thumb {
    /*滚动条里面小方块*/
    border-radius: $width;
    background: #555;
  }

  &::-webkit-scrollbar-track {
    /*滚动条里面轨道*/
    border-radius: $width;
    background: #d9d9d9;
  }
}

.kpfs-logo {
  position: absolute;
  @include w(82);
  @include l(26);
  @include t(33);
  @include bg("logo.png");
}

.tick-model{
  .model{
    background-color:transparent!important;
  }
}
</style>
